import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { QueryClient } from '@tanstack/react-query';

import authReducer from "./auth/authReducer";
import userReducer from "./user/userReducer";
import usersReducer from "./other-users/usersReducer";
import friendReducer from "./friend/friendReducer";
import storyReducer from "./story/storyReducer";
import postReducer from "./post/postReducer";
import commentReducer from "./comment/commentReducer";
import reelsReducer from "./reels/reelsReducer";
import groupReducer from "./group/groupReducer";
import eventReducer from "./event/eventReducer";
import albumReducer from './album/albumReducer';
import chatReducer from "./chat/chatReducer";
import settingsReducer from './setting/settingsReducer';
import notifcationReducer from './notification/notificationReducer';
import reportReducer from './report/reportReducer'; // 👈 added

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  users: usersReducer,
  friend: friendReducer,
  story: storyReducer,
  post: postReducer,
  comment: commentReducer,
  reels: reelsReducer,
  group: groupReducer,
  event: eventReducer,
  album: albumReducer,
  chat: chatReducer,
  settings: settingsReducer,
  notifications: notifcationReducer,
  report: reportReducer, 
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export const queryClient = new QueryClient();
export default store;
